import * as React from 'react'
import Box from '@mui/material/Box'
import Sidebar from './Sidebar'

// LAP — habillage « sidebar permanente » appliqué à toute l'app (desktop
// uniquement, cf. MobileShell pour le mobile). Header (NavBar) reste un
// sibling plein largeur au-dessus ; ce wrapper ne couvre que la zone de
// contenu (AppRouters), en flex row Sidebar + contenu — cf. demande Alexis
// « style SAP Ariba » (screenshot 2).
export default function SidebarLayout({ children }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', width: '100%' }}>
      <Sidebar />
      <Box component="main" sx={{ flexGrow: 1, minWidth: 0 }}>
        {children}
      </Box>
    </Box>
  )
}
